import Vue from "vue";
import Toast from "./index.vue";
let ToastConstructor = Vue.extend(Toast);
export default function (message) {
  let toast = new ToastConstructor({
    destroyed() {
      document.body.removeChild(this.$el);
    }
  });
  toast.message = message;
  toast.$on("dialog-leave", () => toast.$destroy());
  toast.$mount();
  document.body.appendChild(toast.$el);
  return toast;
}
